export const COLOR_CHIP = {
  PRODUCTS_WHITE: 'WHITE',
  PRODUCTS_SIMPLYWHT: 'SIMPLYWHT',
};
export default {
  COLOR_CHIP,
};
